import { Component, Input } from '@angular/core';
import { IconService } from '../Services/icon.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-icon',
  template: `<span [innerHTML]="iconHtml" [style.width]="size" [style.height]="size" [style.display]="'inline-block'"></span>`,
  styles: [`
    :host {
      display: inline-block;
      vertical-align: middle;
      margin-top: -21px;
    }
    :host span {
      display: inline-block;
      vertical-align: middle;
    }
    :host span svg {
      width: 100% !important;
      height: 100% !important;
      vertical-align: middle;
    }
  `],
  standalone: true
})
export class IconComponent {
  @Input() name!: string;
  @Input() size = '18px';

  constructor(private iconService: IconService, private sanitizer: DomSanitizer) {}

  get iconHtml(): SafeHtml {
    const rawIcon = this.iconService.getIcon(this.name);
    if (rawIcon) {
      // Get the actual HTML string from SafeHtml
      const iconString = (rawIcon as any).changingThisBreaksApplicationSecurity || rawIcon.toString();
      // Remove existing width/height and add our size
      const modifiedIcon = iconString
        .replace(/width="[^"]*"/g, `width="${this.size}"`)
        .replace(/height="[^"]*"/g, `height="${this.size}"`);
      return this.sanitizer.bypassSecurityTrustHtml(modifiedIcon);
    }
    return this.sanitizer.bypassSecurityTrustHtml('');
  }
}